/* eslint-disable import/prefer-default-export */
import { ALL_DATA_PROJECT } from '@/utils/constants'

export const selectedProjectId = (state) => {
  const { activeProjectId } = state
  return activeProjectId === ALL_DATA_PROJECT.id ? undefined : activeProjectId
}
